import { asyncScheduler, defer, Observable, observeOn, of } from "rxjs"
import { StateStorageAdapter } from "../state-storage.model"

export class WebStorageAdapter<T> implements StateStorageAdapter<T> {
  constructor(private storage: Storage, private key: string) {}

  read(): Observable<T | null> {
    return defer(() => {
      const raw = this.storage.getItem(this.key)
      if (!raw) {
        return of(null)
      }

      try {
        return of(JSON.parse(raw) as T)
      } catch {
        return of(null)
      }
    }).pipe(observeOn(asyncScheduler))
  }

  write(state: T): Observable<void> {
    return defer(() => {
      this.storage.setItem(this.key, JSON.stringify(state))
      return of(void 0)
    }).pipe(observeOn(asyncScheduler))
  }

  clear(): Observable<void> {
    return defer(() => {
      this.storage.removeItem(this.key)
      return of(void 0)
    }).pipe(observeOn(asyncScheduler))
  }
}

export const createLocalStorageAdapter = <T>(key: string) =>
  new WebStorageAdapter<T>(localStorage, key)

export const createSessionStorageAdapter = <T>(key: string) =>
  new WebStorageAdapter<T>(sessionStorage, key)
